<script setup>
import { defineProps } from "vue";
import CardCotizacionTotales from "./CardCotizacionTotales";
import EstatusCotizacion from "./EstatusCotizacion.vue";
import useStoreCotizaciones from "@/store/cotizaciones";
import { computed, onMounted, onUnmounted, ref } from "vue";
import { storeToRefs } from "pinia";
import { useRoute } from "vue-router";
import ArgonSwitch from "../../../components/ArgonSwitch";
import useCotizacion from "@/composables/useCotizacion";

const props = defineProps({
  datos: {
    type: Object,
    required: true,
  },
  totales: {
    type: Object,
    required: true,
  },
  showSwitch: {
    type: Boolean,
    default: true,
  },
  showCopyBtn: {
    type: Boolean,
    default: false,
  },
  showRedireccion: {
    type: Boolean,
    default: false,
  },
});

const { modificarTotales, modificando } = useCotizacion();

const useCotizacionStore = useStoreCotizaciones();
const {
  plazo12,
  plazo24,
  plazo36,
  plazo48,
  plazo60,
  mostrarRedireccion,
  labelRedirige,
} = storeToRefs(useCotizacionStore);
const { urlCotizacionPreview, plazoTotal } = useCotizacionStore;
const route = useRoute();

const url = ref(
  process.env.VUE_APP_URL +
    `public/cotizacion/${route.params.token}/preview?plazo=${plazoTotal()}`
);

const publicURL = computed(() => {
  return url.value + labelRedirige.value;
});

const message = computed(() => {
  return `¡Hola, ${props.datos.nombre_cliente} !

Se ha generado tu cotización por parte del equipo de ${
    process.env.VUE_APP_BRAND
  }. Para poder observar la misma es necesario dar click en el siguiente enlace:

${process.env.VUE_APP_URL}public/cotizacion/${
    route.params.token
  }/preview?plazo=${plazoTotal()}${labelRedirige.value}`;
});

const copyURLtoClipboard = async () => {
  const copyText = document.getElementById("urlText");
  copyText.select();
  copyText.setSelectionRange(0, 99999); // For mobile devices
  console.log(message);
  console.log(labelRedirige.value);
  await navigator.clipboard.writeText(copyText.value);
};

const plazos = route.query.plazo;

const plazoIndividual = [];

for (let i = 0; i < plazos.length; i += 2) {
  plazoIndividual.push(plazos.slice(i, i + 2));
}

plazo12.value = plazoIndividual[0];
plazo24.value = plazoIndividual[1];
plazo36.value = plazoIndividual[2];
plazo48.value = plazoIndividual[3];
plazo60.value = plazoIndividual[4];

onUnmounted(() => {
  plazo12.value = "12";
  plazo24.value = "24";
  plazo36.value = "36";
  plazo48.value = "48";
  plazo60.value = "60";
  mostrarRedireccion.value = true;
});

const token = useRoute().params.token
const usuarioId = localStorage.getItem("_id")
</script>

<template>
  <section class="p-md-5">
    <div class="row">
      <div class="p-3 pt-0 pb-5 card-header bg-transparent">
        <div
          class="d-flex flex-row justify-content-end align-items-center pb-5"
          v-if="showRedireccion"
          @change="mostrarRedireccion = !mostrarRedireccion"
        >
          <argon-switch id="formRedirige" :checked="mostrarRedireccion"
            >Redirigir al aprobar</argon-switch
          >
        </div>
        <div class="d-flex flex-row justify-content-between align-items-center">
          <h6 class="mb-0">Cotización #{{ datos.id }}</h6>
          <button
            v-if="showCopyBtn"
            class="btn btn-xs rounded-pill bg-gradient-secondary mb-0"
            @click="copyURLtoClipboard"
          >
            <i class="ri-clipboard-line me-1"></i>
            Copiar URL
          </button>
          <a
            :href="urlCotizacionPreview($route.params.token)"
            target="_blank"
            class="btn rounded-pill btn-xs bg-gradient-secondary mb-0"
          >
            <i class="ri-file-4-line me-2"></i>Ver cotización
          </a>
        </div>
      </div>
    </div>
    <div class="row px-3 py-4 bg-dark text-white">
      <div class="col-md-7">
        <div class="d-flex flex-column h-100 justify-content-center">
          <img
            src="https://ventusleasing.mx/wp-content/uploads/2023/04/Logotipo-Ventus-Leasing-Arrendamiento-Puro-Financiamiento-Activos-1-1.png"
            width="200"
          />
        </div>
      </div>
      <div class="col-md-5 text-small">
        <small>
          Torreón<br />
          Carretera San Pedro de las Colinas 2200, Torreón, Coah</small
        >
        <br />
        <small>
          <span>Monterrey</span><br />
          Av. Lázaro Cárdenas 1007, San Pedro Garza García, NL<br />
          ventas@ventusleasing.com | www.ventusleasing.com>
        </small>
      </div>
    </div>
    <div class="row col-md-11 mx-auto">
      <div class="col-md-7">
        <div class="mb-n4">
          <span class="bg-warning px-4 py-1 rounded-bottom text-dark"
            >Cliente</span
          >
        </div>
      </div>
      <div class="col-md-5">
        <div class="mb-n4">
          <span class="bg-warning px-4 py-1 rounded-bottom text-dark"
            >Atención a cliente</span
          >
        </div>
      </div>
    </div>
    <div class="row w-100 m-0">
      <div class="col-lg-11 mx-auto col-sm-12 mt-4">
        <div class="">
          <textarea
            id="urlText"
            v-model="message"
            rows="7"
            v-show="false"
            class="form-control"
          ></textarea>
          <EstatusCotizacion
            :estatus="datos.estatus"
            :plazo_aprobado="datos.plazo_aprobado"
            :motivo_rechazo="datos.comentario"
          />
          <div class="py-3">
            <div class="row">
              <div class="col-md-7">
                <div>
                  <p>
                    <span>{{ datos.empresa }}</span
                    ><br />
                    <span
                      ><b>{{ datos.nombre_cliente }}</b></span
                    ><br />
                    <span>{{ datos.correo }}</span
                    ><br />
                    <span>{{ datos.telefono }}</span
                    ><br />
                    <span>{{ datos.residencia }}</span
                    ><br />
                  </p>
                </div>
              </div>
              <div class="col-md-5">
                <div>
                  <p>
                    <span>Agente de Ventas - Ventus</span><br />
                    <span>comercial@ventusleasing.com</span><br />
                  </p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-7">
                <div class="row my-2 px-3">
                  <div class="col-md-4">
                    <span>Tipo de operación</span>
                  </div>
                  <div class="col-md-8">
                    <div class="bg-light rounded text-center p-1">
                      Arrendamiento Puro
                    </div>
                  </div>
                </div>
                <div class="row my-2 px-3">
                  <div class="col-md-4">
                    <span>Valor del bien arrendado</span>
                  </div>
                  <div class="col-md-8">
                    <div class="bg-light rounded text-center p-1">
                      ${{ datos.importe }}
                    </div>
                  </div>
                </div>
                <div class="row my-2 px-3">
                  <div class="col-md-4">
                    <span>Tipo de equipo</span>
                  </div>
                  <div class="col-md-8">
                    <div class="bg-light rounded text-center p-1">
                      {{ datos.arrendamiento_tipo }}
                    </div>
                  </div>
                </div>
                <div class="row my-2 px-3">
                  <div class="col-md-4">
                    <span>Descripción</span>
                  </div>
                  <div class="col-md-8">
                    <div class="bg-light rounded text-center p-1">
                      {{ datos.descripcion }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-5">
                <div class="row my-2 px-3">
                  <div class="col-md-4">
                    <span>Fecha cotización</span>
                  </div>
                  <div class="col-md-8">
                    <div class="bg-dark text-white rounded text-center p-1">
                      {{ datos.fecha }}
                    </div>
                  </div>
                </div>
                <div class="row my-2 px-3">
                  <div class="col-md-4">
                    <span>Fecha vencimiento</span>
                  </div>
                  <div class="col-md-8">
                    <div class="bg-dark text-white rounded text-center p-1">
                      {{ datos.fecha_vencimiento }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-11 mx-auto">
      <div class="text-end">
        <button class="btn btn-secondary btn-sm" @click="modificarTotales(token)" v-if="usuarioId == 9">
          <span
            class="spinner-border spinner-border-sm me-1"
            role="status"
            aria-hidden="true"
            v-show="modificando"
          ></span>
          Modificar totales
        </button>
      </div>
      <div class="table-responsive">
        <table class="table text-dark">
          <thead>
            <tr>
              <th v-if="showSwitch"></th>
              <th class="m-0 p-0 border-bottom border-dark">
                <div class="bg-dark text-white pt-1 rounded-top px-4">
                  <small>Plazo a<br />seleccionar</small>
                </div>
              </th>
              <th class="bg-light border-bottom border-dark">
                <div>
                  <h3>1</h3>
                  <span>Pago inicial total</span><br />
                  <small>Valor neto</small>
                </div>
              </th>
              <th class="bg-warning border-bottom border-dark">
                <div>
                  <h3>2</h3>
                  <span>Renta mensual (mas IVA)</span><br />
                  <small v-if="datos.tiene_seguro == 1">Incluye seguro</small>
                  <small v-else>No incluye seguro</small>
                </div>
              </th>
              <th class="bg-light border-bottom border-dark">
                <div>
                  <h3>3</h3>
                  <span>Opción de compra</span><br />
                  <small
                    >Valor neto
                    <span style="font-size: 9px"
                      >(al finalizar el contrato)</span
                    ></small
                  >
                </div>
              </th>
              <th class="m-0 p-0 border-bottom border-dark text-center">
                <div class="bg-dark text-white pt-1 rounded-top px-4">
                  <small>Ahorro estimado<br />de ISR</small>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <CardCotizacionTotales
              :totales="totales[index]"
              v-for="({ plazo }, index) in totales"
              :key="plazo"
              :showSwitch="showSwitch"
              :index="index"
            />
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<style>
.bg-dark {
  background: #000 !important;
}
</style>
